const menuItems = [
  {
    path: "/",
    name: "Home",
  },
  {
    path: "/what-is-wubalu",
    name: "Descubre Wubalu",
  },
  {
    path: "/how-it-works",
    name: "Cómo funciona",
  },
  {
    path: "/pricing",
    name: "Precios",
  },
];

export default menuItems;
